import { render, staticRenderFns } from "./aladin-chart.vue?vue&type=template&id=7808487f"
import script from "./aladin-chart.vue?vue&type=script&lang=js"
export * from "./aladin-chart.vue?vue&type=script&lang=js"
import style0 from "./aladin-chart.vue?vue&type=style&index=0&id=7808487f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports